/**
 * @fileoverview GET handler for the "/sdk/debugger/:recording_id/logs" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { sdkDebuggerRecordingIdLogs } from "./constants";
import type { SdkDebuggerRecordingIdLogsResult } from "./types";

export const getSdkDebuggerRecordingIdLogs = reactQueryFetcherAdapter(
  sdkDebuggerRecordingIdLogs,
  (signal: AbortSignal, recordingId: string): Promise<SdkDebuggerRecordingIdLogsResult> => {
    return fetch(`/sdk/debugger/${recordingId}/logs`, "GET", {}, { signal }, { propagateFetchRequestError: false });
  }
);
